import { FC } from 'react';

interface TopZonesBarsProps {
  data: ZoneRow[];
}

export const TopZonesBars: FC<TopZonesBarsProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div
        className="nb-hatch flex items-center justify-center py-10 text-[11px] font-bold uppercase tracking-[0.08em] opacity-60"
        style={{
          fontFamily: '"JetBrains Mono", monospace',
          border: '2px dashed var(--nb-ink)',
          background: 'var(--nb-bg)',
          borderRadius: 'var(--nb-radius)',
        }}
      >
        Todavía no hay zonas para mostrar
      </div>
    );
  }

  const maxCount = data[0].count || 1;

  return (
    <div className="flex flex-col gap-3">
      {data.map((row) => {
        const widthPct = (row.count / maxCount) * 100;
        return (
          <div
            key={row.city}
            className="grid items-center gap-3"
            style={{ gridTemplateColumns: 'minmax(90px, 28%) 1fr auto' }}
          >
            <span
              className="truncate text-[11px] font-bold uppercase tracking-[0.06em]"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
              title={row.city}
            >
              {row.city}
            </span>
            <div
              className="fill-solved"
              style={{
                width: `${Math.max(widthPct, 4)}%`,
                height: 20,
                border: '2px solid var(--nb-ink)',
                boxShadow: '2px 2px 0 var(--nb-ink)',
                borderRadius: 'var(--nb-radius)',
              }}
            />
            <span className="font-display text-[18px] leading-none">{row.count}</span>
          </div>
        );
      })}
    </div>
  );
};
